<app-side-nav-outer-toolbar [title]="appInfo.title" [siteThemeConfig]="siteThemeConfig" (parameterSelectionChanged)="onParameterSelectionChanged()">
    <router-outlet></router-outlet>
</app-side-nav-outer-toolbar>

<!--This hides all window content, avoids displaying incorrect theme for a split second-->
<div *ngIf="showLoadingThemeOverlay" class="loading-theme-overlay"></div>
